export default "__VITE_ASSET__Ge$_in9q__"